import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class MediaService {

    constructor(private _http: HttpClient) { }

    getmedia(data) {
        return this._http.post(environment.api_url+'admin/medialibrary/list',data);
    }

    savemedia(data) {
        return this._http.post(environment.api_url+'admin/medialibrary/add',data);
    }

}
